import React from 'react'
import { ExpandCollapseMini as AlliumExpandCollapseMini } from '@telus-uds/components-web'
import alloyEvents from '../../../utils/alloyAnalytics/accordion'

export type ExpandCollapseMiniProps = {
  sysID: string
  entryTitle: string
  expandTitle: string
  collapseTitle: string
  iconPosition?: string
  size?: string
  children?: React.ReactNode
  spacer?: React.ReactNode
  spacerContent?: React.ReactNode
  richText?: React.ReactNode
}

const ExpandCollapseMini = ({
  sysID,
  entryTitle,
  children,
  expandTitle = 'Expanded',
  collapseTitle = 'Collapsed',
  iconPosition = 'right',
  size = 'medium',
  spacer,
  spacerContent,
  richText,
}: ExpandCollapseMiniProps) => {
  return (
    <div>
      {spacer}
      <AlliumExpandCollapseMini
        expandTitle={expandTitle}
        collapseTitle={collapseTitle}
        iconPosition={iconPosition}
        variant={{ size: size }}
        onToggle={(_, isExpand: boolean) => {
          const accordionEvent = isExpand ? alloyEvents.expand : alloyEvents.collapse
          accordionEvent({ sysID, entryTitle, panelID: collapseTitle })
        }}
      >
        {richText}
        {spacerContent}
        {children}
      </AlliumExpandCollapseMini>
    </div>
  )
}

export default ExpandCollapseMini
